<app-layout>
  <app-menu *ngIf="tipoAcesso()"></app-menu>
  <app-voltar route="listagem/agendamento" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form">
      <div class="formList">
        <app-input
          label="Valor do Pagamento"
          placeholder="R$"
          name="VL_SRVC"
          width="100%"
          formControlName="VL_SRVC"></app-input>
        <app-input
          type="select"
          label="Tipo de pagamento"
          name="NU_TIPO_PAGM"
          formControlName="NU_TIPO_PAGM"
          placeholder="Selecione"
          [requiredInput]="true"
          [selectData]="pagamentoOptions"
          (ngModelChange)="escolherTipoPagamento($event)"></app-input>
        <app-input
          *ngIf="isCartao"
          label="Titular do Cartão"
          name="NM_CART"
          width="100%"
          maxLength="20"
          formControlName="NM_CART"
          placeholder="Nome do Titular"
          [requiredInput]="true"></app-input>
        <app-input
          *ngIf="isCartao"
          label="Número do Cartão"
          name="NU_CART"
          width="100%"
          mask="0000.0000.0000.0000"
          formControlName="NU_CART"
          placeholder="0000.0000.0000.0000"
          [requiredInput]="true"></app-input>
        <app-input
          *ngIf="isCartao"
          label="Data de Expiração"
          type="text"
          name="DT_EXPC"
          width="100%"
          formControlName="DT_EXPC"
          mask="00/0000"
          placeholder="MM/AAAA"
          [requiredInput]="true"></app-input>
        <app-input
          *ngIf="isCartao"
          label="Código de Segurança"
          name="CD_SEGU"
          width="100%"
          mask="000"
          placeholder="CVV"
          formControlName="CD_SEGU"
          [requiredInput]="true"></app-input>
        <app-input
          *ngIf="isCartao"
          type="select"
          label="Bandeira do Cartão"
          name="BND_CART"
          formControlName="BND_CART"
          placeholder="Selecione"
          [requiredInput]="true"
          [selectData]="bandeiraCartaoOptions"
          (ngModelChange)="escolherBandeiraCartao($event)"></app-input>
        <input type="hidden" id="SESSION_ID" value="" />
      </div>
      <div class="div-qr-code" *ngIf="this.isPagamentoPixVisivel">
        <div class="flex-col">
          <h2 class="pix-title">Escaneie aqui</h2>
          <img id="qrcode" [src]="qrcodeUrl" alt="QR Code" />

          <h2 class="pix-value">
            Valor: {{ this.form.controls['VL_SRVC'].value }}
          </h2>
        </div>

        <div class="flex-col">
          <img class="pix-logo" src="assets/pix-logo.png" alt="Logo do Pix" />

          <span>Tempo de Expiração</span>
          <countdown
            [config]="countdownConfig"
            class="custom-style"
            (event)="handleEvent($event)">
            <ng-template #tpl let-time>
              <span>{{ time.hours }}</span
              >:<span>{{ time.minutes }}</span
              >:<span>{{ time.seconds }}</span>
            </ng-template>
          </countdown>
          <div class="countdown-caption">
            <p>Horas</p>
            <p>Minutos</p>
            <p>Segundos</p>
          </div>

          <div class="pix-buttons">
            <button class="button-pix" (click)="copiarValor(this.qrcodetext)">
              PIX Copia e Cola
              <img
                src="assets/icon-copy.svg"
                id="iconeCopia"
                cursor="pointer" />
            </button>
            <button class="button-pix" (click)="this.navegar()">
              Já paguei
            </button>
          </div>
        </div>
      </div>
      
      <div class="div-url-debito" *ngIf="isDebit && !isCartao">
        <p class="message">
          Para verificar seu pagamento via cartão de débito, clique no botão abaixo:
        </p>
        <a [href]="urlDebito" class="btn-debito">
          Acessar Verificação de Pagamento
        </a>
      </div>

      <app-botao
        type="cadastro"
        text="Concluir Pagamento"
        *ngIf="this.isCartao && !this.ifAfterPost"
        [disabled]="!form.valid"
        (click)="postarDados()"></app-botao>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
